import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import { createBookingPriceWithDiscountInfo } from 'helpers/PriceHelper';
import { defaultCompare } from 'helpers/SortHelper';
import rentalTypes from 'enums/rentalTypes';

import { Helmet } from 'react-helmet-async';

const StorageSiteFacebookMetaTags = ({ storageSite }) => {
    const { appContext } = useAppContext();
    const items = storageSite.storageGroups.map(storageGroup => {
        const booking = {
            startDate: new Date(),
            subscriptionBooking: true,
            area: (storageGroup.rentalType === rentalTypes.customArea.key ? storageGroup.minBookableArea : undefined) ?? 1
        };
        return {
            storageGroup,
            priceInfo: createBookingPriceWithDiscountInfo(booking, storageSite, storageGroup, true, undefined, appContext)
        };
    });
    items.sort((a, b) => defaultCompare(a.priceInfo.displayPrice, b.priceInfo.displayPrice));
    return (
        <Helmet defer={false}>
            <meta property="og:id" content={storageSite.id}/>
            <meta property="og:value" content={items[0].priceInfo.displayPrice}/>
        </Helmet>
    );
};

StorageSiteFacebookMetaTags.propTypes = {
    storageSite: PropTypes.object.isRequired
};

export default StorageSiteFacebookMetaTags;
